import {
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
} from "fleet/constant/media-library";
import { MediaList } from "fleet/view/media-library/media-list";
import PropTypes from "prop-types";
import React from "react";
import { getById } from "redux-store";
import { getIdFromRouterProps } from "util/router";

class MediaListController extends React.PureComponent {
  static get displayName() {
    return "MediaListController";
  }

  static get propTypes() {
    return {
      archive: PropTypes.func,
      editContent: PropTypes.func,
      editContentGroup: PropTypes.func,
      errorMessage: PropTypes.string,
      folders: PropTypes.object,
      moveToFolder: PropTypes.func,
      onError: PropTypes.func,
      onSuccess: PropTypes.func,
      resetPageState: PropTypes.func,
      showSidebar: PropTypes.func,
      selected: PropTypes.array,
      selectMedia: PropTypes.func,
      successMessage: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      archive: () => {},
      editContent: () => {},
      errorMessage: "",
      folders: {},
      moveToFolder: () => {},
      onError: () => {},
      onSuccess: () => {},
      resetPageState: () => {},
      showSidebar: () => {},
      selected: [],
      selectMedia: () => {},
      successMessage: "",
    };
  }

  constructor(props) {
    super(props);

    this.mediaTypes = [MEDIA_ENTRY_USER_CONTENT, MEDIA_ENTRY_CONTENT_GROUP];
  }

  componentWillUnmount(props) {
    this.props.resetPageState();
  }

  _getMediaTypes(folder) {
    return [...this.mediaTypes, ...(folder ? [] : [MEDIA_ENTRY_FOLDER])];
  }

  _getTitle(folder) {
    return folder ? folder.name : "Media Library";
  }

  render() {
    const folderId = getIdFromRouterProps(this.props);
    const folder = getById(this.props.folders, folderId);

    const mediaTypes = this._getMediaTypes(folder);
    const title = this._getTitle(folder);

    return (
      <MediaList
        folder={folder}
        mediaTypes={mediaTypes}
        title={title}
        {...this.props}
      />
    );
  }
}

export { MediaListController };
